// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { State } from "./State";
import { StateFromJSON, StateFromJSONTyped, StateToJSON, StateToJSONTyped } from "./State";

/**
 *
 * @export
 * @interface PublicationVersionDescriptor
 */
export interface PublicationVersionDescriptor {
  /**
   *
   */
  dataType?: string | null;
  /**
   *
   */
  meta?: { [key: string]: any } | null;
  /**
   *
   */
  views?: Array<string>;
  /**
   *
   */
  layers?: Array<{ [key: string]: any }>;
  /**
   *
   */
  description?: string;
  /**
   *
   */
  status: State;
  /**
   *
   */
  allowsMapLayer?: boolean;
}

/**
 * Check if a given object implements the PublicationVersionDescriptor interface.
 */
export function instanceOfPublicationVersionDescriptor(
  value: object
): value is PublicationVersionDescriptor {
  if (!("status" in value) || value["status"] === undefined) return false;
  return true;
}

export function PublicationVersionDescriptorFromJSON(json: any): PublicationVersionDescriptor {
  return PublicationVersionDescriptorFromJSONTyped(json, false);
}

export function PublicationVersionDescriptorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PublicationVersionDescriptor {
  if (json == null) {
    return json;
  }
  return {
    dataType:
      json["data_type"] === undefined
        ? undefined
        : json["data_type"] === null
        ? null
        : json["data_type"],
    meta: json["meta"] === undefined ? undefined : json["meta"] === null ? null : json["meta"],
    views: json["views"] == null ? undefined : json["views"],
    layers: json["layers"] == null ? undefined : json["layers"],
    description: json["description"] == null ? undefined : json["description"],
    status: StateFromJSON(json["status"]),
    allowsMapLayer: json["allows_map_layer"] == null ? undefined : json["allows_map_layer"],
  };
}

export function PublicationVersionDescriptorToJSON(json: any): PublicationVersionDescriptor {
  return PublicationVersionDescriptorToJSONTyped(json, false);
}

export function PublicationVersionDescriptorToJSONTyped(
  value?: PublicationVersionDescriptor | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    data_type: value["dataType"],
    meta: value["meta"],
    views: value["views"],
    layers: value["layers"],
    description: value["description"],
    status: StateToJSON(value["status"]),
    allows_map_layer: value["allowsMapLayer"],
  };
}
